export const SITE_MESSAGES = {
  RIGHT_CLICK_DISABLED_MESSAGE: "Right click disabled for security reasons",
};
